export const NODE_AVAILABILITY_OPTIONS = [
  { value: "available", label: "Available" },
  { value: "unavailable", label: "Unavailable" },
];

const isUnavailable = (record) =>
  Boolean(record && ["unavailable", "out_of_contract"].includes(record.availabilityStatus));

// Missing fields remain Available. Preserve the previous label's stored value.
// Inheritance is derived so re-enabling a node restores each customer's setting.
export const getAvailabilityStatus = (record, parentNode) =>
  isUnavailable(parentNode) || isUnavailable(record) ? "unavailable" : "available";

export const getAvailabilityLabel = (record, parentNode) =>
  getAvailabilityStatus(record, parentNode) === "unavailable"
    ? "Unavailable"
    : "Available";

export const isNodeBookingAvailable = (node) =>
  Boolean(node) && getAvailabilityStatus(node) === "available";
